<template>
  <div class="elevBluetoothEquipManagesList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="gardenId" @change="getListHouse" disabled>
            <el-option key :label="$t('lang.lab_chooseGarden')" :value="0"></el-option>
            <el-option v-for="(item,index) in types" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="houseId" @change="getListUnit">
            <el-option key :label="$t('lang.lab_selectHouse')" :value="0"></el-option>
            <el-option v-for="(item,index) in houseList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="unitId">
            <el-option key :label="$t('lang.lab_selectUnit')" :value="0"></el-option>
            <el-option v-for="(item,index) in unitList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="searchMacName" :placeholder="$t('lang.lab_macName')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_elevBluetoothEquipManagesAdd')}}</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="macName" :label="$t('lang.lbl_elevBluetoothEquipManages_macName')"></el-table-column>
        <el-table-column prop="name" :label="$t('lang.lbl_elevBluetoothEquipManages_name')"></el-table-column>
        <el-table-column prop="houseName" :label="$t('lang.lbl_elevBluetoothEquipManages_houseName')"></el-table-column>
        <el-table-column prop="unitName" :label="$t('lang.lbl_elevBluetoothEquipManages_unitName')"></el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <!-- <el-button @click="xlElevatorList(scope.row.id)">{{$t('lang.lab_xlDevice')}}</el-button> -->
            <el-button class="orange" @click="deletetable(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout=" sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <el-dialog :title=title :visible.sync="isPopupPage" :close-on-click-modal="false" center top="130px" width="600px"
      @closed="handleDialogClosed">
      <el-form :model="diaForm" :rules="rules" ref="diaForm" :label-width="require('@/config/enum').c_ws8"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.diaFormgarden')" prop="garden">
          <el-select v-model="diaForm.garden" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormgarden')"
            class="select" disabled>
            <el-option key="0" :label="$t('lang.lab_please_Select')+$t('lang.diaFormgarden')" :value='0'></el-option>
            <el-option v-for="item in gardenDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.diaFormhouse')" prop="house">
          <el-select v-model="diaForm.house" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormhouse')"
            class="select" @change="getUnit">
            <el-option key="0" :label="$t('lang.lab_please_Select')+$t('lang.diaFormhouse')" :value='0'></el-option>
            <el-option v-for="item in houseDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.diaFormunit')" prop="unit">
          <el-select v-model="diaForm.unit" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormunit')"
            class="select">
            <el-option key="0" :label="$t('lang.lab_please_Select')+$t('lang.diaFormunit')" :value='0'></el-option>
            <el-option v-for="item in unitDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lbl_elevBluetoothEquipManages_name')" prop="name">
          <el-input :placeholder="$t('lang.lab_please_Input')+$t('lang.lbl_elevBluetoothEquipManages_name')"
            v-model="diaForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.diaFormmacName')" prop="macName">
          <el-input :placeholder="$t('lang.lab_please_Input')+$t('lang.diaFormmacName')" v-model="diaForm.macName">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear('diaForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="save('diaForm')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:elevBluetoothEquipManagesList
   *@Description:电梯蓝牙设备管理
   *@author:刘彦辰
   *@Copyright:格众科技
   *@date:2020-03-23
   */
  export default {
    name: '/manage/main.liftList',
    data() {
      var positiveIntegerChenk = (rule, value, callback) => {
        if (value === 0) {
          callback(new Error(this.$i18n.t('lang.lab_please_Select')))
        } else {
          callback()
        }
      }
      return {
        pageCount: 0, // 总页数
        title: '', // 弹框显示的标题
        pageNo: 1, // 第几页
        pageSize: 10, // 每页显示数
        editId: '',
        types: [], // 小区下拉
        houseId: 0, // 楼号ID
        unitId: 0, // 单元号ID
        houseList: [], // 楼号列表
        unitList: [], // 单元号列表
        multipleSelection: [], // 多选框
        tableData: [], // 列表数组
        searchMacName: '', // 搜索的关键字
        postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
        isDisabled: true, // 保存的可点击
        isPopupPage: false, // 弹框的显示控制
        isAdd: false, // 标识新增(true)或编辑(false)
        gardenId: this.$store.getters.gardenId, // 小区绑定的id
        diaForm: {
          garden: 0, // 所属小区
          house: 0, // 所属楼号
          unit: 0, // 所属单元
          name: '', // 电梯设备名称
          macName: '', // 电梯设备Mac地址
        },
        rules: {
          garden: [{
            required: true,
            validator: positiveIntegerChenk,
            trigger: 'change'
          }],
          house: [{
            required: true,
            validator: positiveIntegerChenk,
            trigger: 'change'
          }],
          unit: [{
            required: true,
            validator: positiveIntegerChenk,
            trigger: 'change'
          }],
          name: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t(
              'lang.lbl_elevBluetoothEquipManages_name'),
            trigger: 'blur'
          }],
          macName: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.diaFormmacName'),
            trigger: 'blur'
          }]
        },
        gardenDialist: [], // 所属小区列表
        houseDialist: [], // 所属楼号列表
        unitDialist: [], // 所属单元列表
        name: '', // 电梯设备名称
        macName: '', // 电梯设备Mac地址
      }
    },
    created() {
      this.getTablelist()
      this.getGarden()
      this.getListHouse()
    },
    watch: {
      diaForm: {
        handler(newVal, oldVal) {
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      // 清空弹框
      clear(diaForm) {
        this.diaForm.unit = 0
        this.diaForm.house = 0
        this.diaForm.garden = this.$store.getters.gardenId
        this.diaForm.name = ''
        this.diaForm.macName = ''
        setTimeout(() => {
          this.$refs[diaForm].clearValidate()
        }, 0)
        this.getHouse()
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 所属小区下拉列表获取
      getGarden() {
        let loading = this.$loading()
        this.$get(`/gardens`).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.types = res.list
              this.gardenDialist = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 获取小区下的楼号
      getListHouse() {
        this.houseId = 0
        this.houseList = []
        this.unitId = 0
        this.unitList = []
        this.type = 1
        let loading = this.$loading()
        this.$get(`/gardenGrids?type=${this.type}&parentId=${this.gardenId}&pageNo=1&pageSize=999`).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.houseList = res.list
              if (this.gardenId === 0) {
                this.houseId = 0
                this.houseList = []
                this.unitId = 0
                this.unitList = []
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 获取楼号下的单元号
      getListUnit() {
        this.unitId = 0
        this.unitList = []
        this.type = 2
        let loading = this.$loading()
        this.$get(`/gardenGrids?type=${this.type}&parentId=${this.houseId}&pageNo=1&pageSize=999`).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.unitList = res.list
              if (this.houseId === 0) {
                this.unitId = 0
                this.unitList = []
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 监听关闭dialog
      handleDialogClosed() {
        this.diaForm.unit = 0
        this.diaForm.house = 0
        this.diaForm.garden = 0
        this.diaForm.name = ''
        this.diaForm.macName = ''
        this.$refs.diaForm.clearValidate()
      },
      // 列表隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 所属楼号下拉列表获取
      getHouse() {
        this.diaForm.house = 0
        this.houseDialist = []
        this.diaForm.unit = 0
        this.unitDialist = []
        this.type = 1
        let loading = this.$loading()
        this.$get(`/gardenGrids?type=${this.type}&parentId=${this.$store.getters.gardenId}&pageNo=1&pageSize=999`).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.houseDialist = res.list
              if (this.diaForm.garden === 0) {
                this.diaForm.house = 0
                this.houseDialist = []
                this.diaForm.unit = 0
                this.unitDialist = []
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 所属单元下拉列表获取
      getUnit() {
        this.diaForm.unit = 0
        this.unitDialist = []
        this.type = 2
        let loading = this.$loading()
        this.$get(`/gardenGrids?type=${this.type}&parentId=${this.diaForm.house}&pageNo=1&pageSize=999`).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.unitDialist = res.list
              if (this.diaForm.house === 0) {
                this.diaForm.unit = 0
                this.unitDialist = []
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 电梯蓝牙设备管理
      getTablelist() {
        let loading = this.$loading()
        this.$get(
          `/lift/?garden=${this.gardenId}&house=${this.houseId}&unit=${this.unitId}&name=${this.searchMacName}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
          ).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getTablelist()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getTablelist()
      },
      edit(row) {
        this.title = this.$i18n.t('lang.btn_elevBluetoothEquipManagesEdit')
        this.editId = row.id
        this.diaForm.garden = row.gardenId
        this.type = 1
        this.$get(`/gardenGrids?type=${this.type}&parentId=${this.diaForm.garden}&pageNo=1&pageSize=999`).then(res => {
            if (res && res.errCode === 0) {
              this.houseDialist = res.list
            }
          },
          error => {
            this.$message.error(error)
          })
        this.diaForm.macName = row.macName
        this.diaForm.name = row.name
        this.diaForm.unit = row.unit
        this.diaForm.house = row.house
        if (this.diaForm.house === null || this.diaForm.house === 0) {
          this.diaForm.house = 0
          this.unitDialist = []
        } else {
          this.type = 2
          this.$get(`/gardenGrids?type=${this.type}&parentId=${this.diaForm.house}&pageNo=1&pageSize=999`).then(res => {
              if (res && res.errCode === 0) {
                this.unitDialist = res.list
              }
            },
            error => {
              this.$message.error(error)
            })
        }
        if (this.diaForm.unit === null) {
          this.diaForm.unit = 0
        }
        this.saveData = JSON.stringify(this.diaForm)
        this.isPopupPage = true
      },
      add() {
        this.editId = ''
        this.title = this.$i18n.t('lang.btn_elevBluetoothEquipManagesAdd')
        this.diaForm.unit = 0
        this.diaForm.house = 0
        this.diaForm.garden = this.$store.getters.gardenId
        this.diaForm.name = ''
        this.diaForm.macName = ''
        this.isDisabled = false
        this.isPopupPage = true
        this.getHouse()
      },
      save(diaForm) {
        if (this.editId === '') {
          this.$refs[diaForm].validate((valid) => {
            if (valid) {
              if (this.diaForm.typeId === '') {
                this.$message.error(this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.diaFormtypeId'))
              } else {
                let params = {
                  garden: this.diaForm.garden,
                  house: this.diaForm.house,
                  unit: this.diaForm.unit,
                  name: this.diaForm.name,
                  macName: this.diaForm.macName
                }
                let loading = this.$loading()
                this.$post(`/lift`, params).then(
                  res => {
                    loading.close()
                    if (res && res.errCode === 0) {
                      this.$message.success(this.$i18n.t('lang.lab_save_success'))
                      this.isPopupPage = false
                      this.pageNo = 1
                      this.getTablelist()
                    }
                    setTimeout(() => {
                      loading.close()
                    }, 200)
                  },
                  error => {
                    loading.close()
                    this.$message.error(error)
                  }
                )
              }
            } else {
              return false
            }
          })
        } else {
          this.$refs[diaForm].validate((valid) => {
            if (valid) {
              let loading = this.$loading()
              let params = {
                garden: this.diaForm.garden,
                house: this.diaForm.house,
                unit: this.diaForm.unit,
                name: this.diaForm.name,
                macName: this.diaForm.macName
              }
              this.$patch(`/lift/${this.editId}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.isPopupPage = false
                    this.commit()
                  }
                  setTimeout(() => {
                    loading.close()
                  }, 200)
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              return false
            }
          })
        }
      },
      commit() {
        this.pageNo = 1
        this.getTablelist()
      },
      deletetable(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            // 添加del的url
            this.$delete(`/lift/` + id).then(res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              })
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 跳转星朗设备
      xlElevatorList(id) {
        this.$router.push({
          path: '/manage/xlElevator',
          query: {
            id: id
          }
        })
      },
    }
  }
</script>

<style lang="scss">
</style>